module.exports = __webpack_public_path__ + "static/img/2bw.6f24489f.webp";